export const fetchAuth = `https://upd-alternative-housing-api.onrender.com`

//export const fetchAuth = `http://localhost:3001`